/* MAISÈNE — Frontend-Logik: Logo, Farbkacheln, Größenassistent */
(function () {
  'use strict';

  /* ---------------- Logo in den Header setzen ---------------- */
  function mountLogo() {
    var tpl = document.getElementById('MaiseneLogoSvg');
    if (!tpl) return;
    var targets = document.querySelectorAll('.site-header__logo a, .site-header__logo-link, .header__logo a, [data-m-logo-target]');
    targets.forEach(function (a) {
      if (a.dataset.mLogoDone) return;
      a.dataset.mLogoDone = '1';
      a.classList.add('m-logo');
      a.innerHTML = tpl.innerHTML;
    });
  }

  /* ---------------- Farbkacheln <-> native Varianten ---------------- */
  function mountSwatches() {
    document.querySelectorAll('[data-m-swatches]').forEach(function (box) {
      if (box.dataset.mReady) return;
      box.dataset.mReady = '1';
      var optIndex = box.getAttribute('data-option-index');
      box.addEventListener('click', function (e) {
        var tile = e.target.closest('.m-swatch');
        if (!tile) return;
        var value = tile.getAttribute('data-value');
        var wrap = document.querySelector('.variant-wrapper[data-index="option' + optIndex + '"], .variant-wrapper[data-m-color]');
        var input = null;
        if (wrap) {
          input = wrap.querySelector('input[value="' + CSS.escape(value) + '"]');
          if (!input) {
            var sel = wrap.querySelector('select');
            if (sel) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        }
        if (!input) {
          input = document.querySelector('.variant-input input[value="' + CSS.escape(value) + '"]');
        }
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        box.querySelectorAll('.m-swatch').forEach(function (t) { t.classList.remove('is-active'); });
        tile.classList.add('is-active');
      });
    });
  }

  /* ---------------- Größenassistent ---------------- */
  var SA = {
    state: { step: 1, gender: null, kind: null, height: null, weight: null, build: null, fitPref: null, foot: null },

    open: function () {
      var o = document.getElementById('MaiseneSizeAssistant');
      if (!o) return;
      var d = o.querySelector('[data-sa]');
      SA.state.gender = d.getAttribute('data-gender');
      SA.state.kind = d.getAttribute('data-kind');
      o.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      SA.reset();
    },
    close: function () {
      var o = document.getElementById('MaiseneSizeAssistant');
      if (!o) return;
      o.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    reset: function () {
      var o = document.getElementById('MaiseneSizeAssistant');
      o.querySelector('[data-sa-form]').style.display = '';
      o.querySelector('[data-sa-result]').classList.remove('is-on');
      o.querySelectorAll('.m-sa__chip').forEach(function (c) { c.classList.remove('is-on'); });
      SA.state.build = null; SA.state.fitPref = null;
    },

    /* Damen-Konfektion aus Gewicht/Größe/Statur */
    womenSize: function (h, w, build, kind, fit) {
      var idx; /* 0=XS 1=S 2=M 3=L 4=XL 5=XXL */
      if (w < 52) idx = 0;
      else if (w < 58) idx = 1;
      else if (w < 65) idx = 2;
      else if (w < 73) idx = 3;
      else if (w < 83) idx = 4;
      else idx = 5;
      /* Körpergröße relativiert das Gewicht */
      if (h >= 178 && idx > 0) idx -= 1;
      if (h <= 160 && w >= 58) idx += 1;
      if (build === 'schlank') idx -= 1;
      if (build === 'kraeftig') idx += 1;
      /* Schnittabhängig */
      if (kind === 'kleid') idx += 1;          /* Kleider fallen enger aus */
      if (kind === 'jacke') idx += 1;          /* Platz für Lagen */
      if (kind === 'strick') idx += 0;
      if (fit === 'eng') idx -= 1;
      if (fit === 'locker') idx += 1;
      return SA.clamp(idx);
    },

    /* Herren-Konfektion */
    menSize: function (h, w, build, kind, fit) {
      var idx;
      if (w < 62) idx = 0;
      else if (w < 72) idx = 1;
      else if (w < 83) idx = 2;
      else if (w < 95) idx = 3;
      else if (w < 108) idx = 4;
      else idx = 5;
      if (h >= 190 && idx < 5) idx += 1;
      if (h <= 170 && idx > 0) idx -= 1;
      if (build === 'schlank') idx -= 1;
      if (build === 'kraeftig') idx += 1;
      if (kind === 'jacke') idx += 1;
      if (fit === 'eng') idx -= 1;
      if (fit === 'locker') idx += 1;
      return SA.clamp(idx);
    },

    clamp: function (i) { return Math.max(0, Math.min(5, i)); },

    LABELS: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    DE_W: ['32/34', '36', '38/40', '42', '44', '46/48'],
    DE_M: ['44/46', '48', '50', '52', '54', '56/58'],

    /* Schuhgröße aus Fußlänge */
    shoeSize: function (cm, fit) {
      var eu = Math.round((parseFloat(cm) + 1.5) * 1.5);
      if (fit === 'eng') eu -= 1;
      if (fit === 'locker') eu += 1;
      return eu;
    },

    /* Empfehlung mit den real verfügbaren Optionen abgleichen */
    matchOption: function (rec, options) {
      var norm = function (s) { return String(s).toUpperCase().replace(/\\s|-|\\./g, ''); };
      var target = norm(rec);
      /* 1. exakter Treffer */
      for (var i = 0; i < options.length; i++) {
        if (norm(options[i]) === target) return options[i];
      }
      /* 2. enthält */
      for (var j = 0; j < options.length; j++) {
        if (norm(options[j]).indexOf(target) > -1 || target.indexOf(norm(options[j])) > -1) return options[j];
      }
      /* 3. numerisch nächstgelegen */
      var num = parseFloat(String(rec).replace(/[^0-9.]/g, ''));
      if (!isNaN(num)) {
        var best = null, bestD = 1e9;
        options.forEach(function (o) {
          var n = parseFloat(String(o).replace(/[^0-9.]/g, ''));
          if (!isNaN(n) && Math.abs(n - num) < bestD) { bestD = Math.abs(n - num); best = o; }
        });
        if (best !== null) return best;
      }
      /* 4. Buchstabengröße nächstgelegen */
      var order = SA.LABELS.indexOf(norm(rec));
      if (order > -1) {
        var b = null, bd = 99;
        options.forEach(function (o) {
          var oi = SA.LABELS.indexOf(norm(o));
          if (oi > -1 && Math.abs(oi - order) < bd) { bd = Math.abs(oi - order); b = o; }
        });
        if (b !== null) return b;
      }
      return null;
    },

    calc: function () {
      var o = document.getElementById('MaiseneSizeAssistant');
      var d = o.querySelector('[data-sa]');
      var kind = SA.state.kind, gender = SA.state.gender;
      var data = JSON.parse(o.querySelector('[data-sa-variants]').textContent || '{}');
      var options = data.sizes || [];
      var rec, alt, human;

      if (kind === 'schuhe') {
        var cm = parseFloat(o.querySelector('[data-sa-foot]').value);
        if (!cm || cm < 18 || cm > 35) { SA.err('Bitte geben Sie eine Fußlänge zwischen 18 und 35 cm an.'); return; }
        var eu = SA.shoeSize(cm, SA.state.fitPref);
        rec = String(eu); alt = String(eu + 1);
        human = 'Bei ' + cm + ' cm Fußlänge passt Ihnen in der Regel Größe ' + eu + '. Wenn Sie dicke Socken tragen, nehmen Sie ' + (eu + 1) + '.';
      } else {
        var h = parseInt(o.querySelector('[data-sa-height]').value, 10);
        var w = parseInt(o.querySelector('[data-sa-weight]').value, 10);
        if (!h || h < 140 || h > 210) { SA.err('Bitte geben Sie eine Körpergröße zwischen 140 und 210 cm an.'); return; }
        if (!w || w < 35 || w > 180) { SA.err('Bitte geben Sie ein Gewicht zwischen 35 und 180 kg an.'); return; }
        if (!SA.state.build) { SA.err('Bitte wählen Sie noch Ihre Statur aus.'); return; }
        var idx = gender === 'herren'
          ? SA.menSize(h, w, SA.state.build, kind, SA.state.fitPref)
          : SA.womenSize(h, w, SA.state.build, kind, SA.state.fitPref);
        rec = SA.LABELS[idx];
        var de = gender === 'herren' ? SA.DE_M[idx] : SA.DE_W[idx];
        alt = SA.LABELS[SA.clamp(idx + 1)];
        human = 'Das entspricht Konfektionsgröße ' + de + '.' +
          (kind === 'kleid' ? ' Kleider dieser Kollektion fallen etwas schmaler aus – wir haben das bereits berücksichtigt.' :
           kind === 'jacke' ? ' Bei Jacken und Mänteln haben wir Platz für einen Pullover darunter eingerechnet.' :
           kind === 'strick' ? ' Strick fällt weich und leicht dehnbar aus.' : '');
      }

      var matched = SA.matchOption(rec, options);
      var res = o.querySelector('[data-sa-result]');
      o.querySelector('[data-sa-form]').style.display = 'none';
      res.classList.add('is-on');
      o.querySelector('[data-sa-size]').textContent = matched || rec;
      o.querySelector('[data-sa-text]').innerHTML = human;
      var altEl = o.querySelector('[data-sa-alt]');
      if (matched && options.length > 1) {
        altEl.textContent = 'Zwischen zwei Größen? Wir empfehlen ' + (matched) + ' – bei ' + (kind === 'jacke' ? 'dicken Pullovern' : 'lockerem Sitz') + ' die nächstgrößere.';
      } else if (!matched) {
        altEl.textContent = 'Diese Größe ist derzeit nicht verfügbar. Schreiben Sie uns – wir sagen Ihnen, wann sie wieder da ist.';
      } else { altEl.textContent = ''; }

      var addBtn = o.querySelector('[data-sa-add]');
      var vid = null;
      if (matched && data.map) { vid = data.map[matched] || null; }
      if (vid) {
        addBtn.style.display = '';
        addBtn.setAttribute('data-variant', vid);
        addBtn.textContent = 'Größe ' + matched + ' in den Warenkorb';
      } else {
        addBtn.style.display = 'none';
      }
    },

    err: function (msg) {
      var o = document.getElementById('MaiseneSizeAssistant');
      var e = o.querySelector('[data-sa-error]');
      e.textContent = msg;
      e.style.display = 'block';
      setTimeout(function () { e.style.display = 'none'; }, 5000);
    },

    add: function (btn) {
      var id = btn.getAttribute('data-variant');
      if (!id) return;
      btn.disabled = true;
      btn.textContent = 'Wird hinzugefügt …';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () {
          btn.disabled = false;
          SA.close();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          var t = document.querySelector('.js-drawer-open-right, [data-m-open-cart], .site-header__cart');
          if (t) { t.click(); } else { window.location.href = '/cart'; }
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = 'Erneut versuchen';
        });
    }
  };

  /* ---------------- Events ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-sa-open]')) { e.preventDefault(); SA.open(); return; }
    if (t.closest('[data-sa-close]')) { e.preventDefault(); SA.close(); return; }
    if (t.closest('[data-sa-go]')) { e.preventDefault(); SA.calc(); return; }
    if (t.closest('[data-sa-back]')) { e.preventDefault(); SA.reset(); return; }
    if (t.closest('[data-sa-add]')) { e.preventDefault(); SA.add(t.closest('[data-sa-add]')); return; }
    var chip = t.closest('.m-sa__chip');
    if (chip) {
      e.preventDefault();
      var group = chip.getAttribute('data-group');
      chip.parentNode.querySelectorAll('.m-sa__chip').forEach(function (c) { c.classList.remove('is-on'); });
      chip.classList.add('is-on');
      if (group === 'build') SA.state.build = chip.getAttribute('data-val');
      if (group === 'fit') SA.state.fitPref = chip.getAttribute('data-val');
      return;
    }
    if (t.id === 'MaiseneSizeAssistant') { SA.close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') SA.close(); });

  function init() { mountLogo(); mountSwatches(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();